<template>
  <div>
    <div class="row">
      <purchase-order
          :key="`resume-purchase-order-${Object.keys(model).length}`"
          v-model="model"
          class="d-print-none"
        />
      <sale-payment
          :key="`resume-sale-payment-${Object.keys(model).length}`"
          v-model="model"
          class="d-print-none"
      />
      <summary-card
          :key="`resume-summary-${Object.keys(model).length}`"
          v-model="model"
          class="d-print-none"
      />
      <img class="d-none d-print-block" src="@/assets/images/jala.svg" alt="JALA Logo" style="height: 25px;margin-bottom: 24px"/>
      <purchase-order-export
          :key="`export-purchase-order-${Object.keys(model).length}`"
          v-model="model"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('purchase_order'),
            'd-print-none': !exportItems.includes('purchase_order')
          }"
      />
      <sale-payment-export
          :key="`export-sale-payment-${Object.keys(model).length}`"
          v-model="model"
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('sale_payment'),
            'd-print-none': !exportItems.includes('sale_payment')
          }"
      />
      <summary-card-export
          :key="`export-summary-${Object.keys(model).length}`"
          v-model="model"
          class="d-none d-print-block"
      />
      <note-export
          :class="{
            'd-none': true,
            'd-print-block': exportItems.includes('note'),
            'd-print-none': !exportItems.includes('note')
          }"
          v-model="(model || {}).description"
      />
      <div class="d-none d-print-block text-center">
        <sign-export/>
      </div>
      <export-footer class="d-none d-print-block"/>
    </div>
  </div>
</template>

<script>
import ExportFooter from './export-footer'
import NoteExport from '../note-export'
import PurchaseOrder from './purchase-order'
import PurchaseOrderExport from './purchase-order-export'
import SalePayment from './sale-payment'
import SalePaymentExport from './sale-payment-export'
import SignExport from './sign-export'
import SummaryCard from './non-factories/summary-card'
import SummaryCardExport from './non-factories/summary-card-export'

export default {
  name: 'non-factory',
  components: {
    ExportFooter,
    NoteExport,
    PurchaseOrder,
    PurchaseOrderExport,
    SalePayment,
    SalePaymentExport,
    SignExport,
    SummaryCard,
    SummaryCardExport,
  },
  props: {
    value: {type: Object, default: function () { return {} }},
    exportItems: {type: Array, default() { return [] }},
  },
  data() {
    return {
      model: this.value,
      payments: this.value?.payments?.sort((a, b) => a.id - b.id) ?? []
    }
  },
}
</script>

<style scoped>

</style>